import { render, staticRenderFns } from "./DetailVoucherGeneral.vue?vue&type=template&id=72a07e2d&scoped=true"
import script from "./DetailVoucherGeneral.vue?vue&type=script&lang=js"
export * from "./DetailVoucherGeneral.vue?vue&type=script&lang=js"
import style0 from "./DetailVoucherGeneral.vue?vue&type=style&index=0&id=72a07e2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a07e2d",
  null
  
)

export default component.exports